module.exports = __webpack_public_path__ + "static/media/timeChnaged.e71d7f30.jpg";